import type {
  AIRSENSORID,
  CreateSensorPayload,
  CreateSensorResponse,
  DeleteSensorResponse,
  SensorDetailResponse,
  SensorListResponse,
  UpdateSensorParams,
  UpdateSensorPayload,
  UpdateSensorResponse,
} from '@/domains/asset-management/types/sensor';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

// helper
const toUrlID = (id: string | number): string => String(id);

export const fetchSensorList = async (params: string = ''): Promise<SensorListResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.airSensorList(params)}`;
  return await request.get(url);
};

export const fetchDetailSensor = async (
  airSensorID: AIRSENSORID
): Promise<SensorDetailResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.detailAirSensor(toUrlID(airSensorID))}`;
  return await request.get(url);
};

export const deleteSensor = async (airSensorID: AIRSENSORID): Promise<DeleteSensorResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.deleteAirSensor(toUrlID(airSensorID))}`;
  return await request.delete(url);
};

export const createSensor = async (
  sensorData: CreateSensorPayload
): Promise<CreateSensorResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.createAirSensor()}`;
  return await request.post(url, sensorData);
};

export const updateSensor = async (
  sensorData: UpdateSensorPayload,
  params: UpdateSensorParams
): Promise<UpdateSensorResponse> => {
  const url = `${URLS.BACK_DSH}${APIS.updateAirSensor(toUrlID(params.air_sensor_id))}`;
  return await request.put(url, sensorData);
};
